<template>
  <div class="space-y-4 p-3">
    <!-- Search Bar - Kompakter & Konsistent -->
    <div class="relative group">
      <div class="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
        <MagnifyingGlassIcon class="h-4 w-4 text-gray-700 dark:text-gray-200 transition-transform group-focus-within:scale-110 group-focus-within:text-blue-600 dark:group-focus-within:text-blue-400" />
      </div>
      <input
        type="text"
        :value="search"
        @input="updateSearch"
        placeholder="Projekte suchen..."
        class="block w-full pl-12 pr-4 py-3.5 bg-white/95 dark:bg-gray-900/95 border border-gray-200/50 dark:border-gray-700/60 rounded-2xl text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-500 shadow-sm text-base font-light"
      />
    </div>

    <!-- Tag Filter Section -->
    <div class="space-y-2">
      <div class="flex items-center justify-between px-2">
        <h3 class="text-[9px] font-black text-gray-700 dark:text-gray-200 uppercase tracking-[0.3em] flex items-center space-x-2">
          <TagIcon class="w-3 h-3" />
          <span>Tech Filter</span>
        </h3>
        <button 
          v-if="selectedTags.length > 0 || search"
          @click="$emit('reset')"
          class="text-[10px] font-bold text-gray-700 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-400 transition-all hover:translate-x-1 uppercase tracking-wider"
        >
          Reset
        </button>
      </div>
      
      <div class="flex flex-wrap gap-2 pt-1">
        <button
          v-for="tag in technologies"
          :key="tag"
          @click="$emit('toggle-tag', tag)"
          type="button"
          class="px-4 py-2 rounded-lg text-xs font-bold transition-all duration-500 border uppercase tracking-wider relative overflow-hidden group"
          :class="[
            selectedTags.includes(tag)
              ? 'bg-blue-600 dark:bg-blue-500 text-white border-blue-600 dark:border-blue-500 shadow-md shadow-blue-500/40 scale-105 z-10'
              : 'bg-white/95 dark:bg-gray-900/95 text-gray-700 dark:text-gray-200 border-gray-200/50 dark:border-gray-700/60 hover:border-blue-500/50 dark:hover:border-blue-400/50 hover:bg-gray-50 dark:hover:bg-gray-800/70'
          ]"
        >
          <span class="relative z-10">{{ tag }}</span>
        </button>
      </div>
    </div>
  </div>
</template>



<script setup lang="ts">
import { MagnifyingGlassIcon, TagIcon } from '@heroicons/vue/24/outline'

defineProps<{
  search: string
  technologies: string[]
  selectedTags: string[]
}>()

const emit = defineEmits(['update:search', 'toggle-tag', 'reset'])

const updateSearch = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:search', target.value)
}
</script>

